const normalize = (value) => (value || '').toString().toLowerCase()

const inventoryMovementProcessButtonLabelMap = (processId, processType, movement = {}) => {
  const normalizedType = normalize(processType)

  if (!processId && !(movement.process_detail_path || movement.detail_path)) return null

  if (normalizedType.includes('internalrequest') || normalizedType.includes('internal_request')) {
    return 'View Internal Request'
  }

  if (normalizedType.includes('seller::outbound::return') || normalizedType.includes('sellerreturn') || normalizedType.includes('seller_return')) {
    return 'View Seller Return'
  }

  // Keep Deal / Outbound / Payment / Shipment movement history visible but read-only.
  
  if (normalizedType.includes('shipment')) {
    return 'View Shipment'
  }

  if (movement.deal_id || movement.dealId || normalizedType.includes('outbound') || normalizedType.includes('deal')) {
    return 'View Deal'
  }

  return movement.process_detail_path || movement.detail_path ? 'Open Process' : null
}

export default inventoryMovementProcessButtonLabelMap
